exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.down-root[data-v-1627e5be] {\n  height: 100vh;\n  overflow: hidden;\n}\n.success-tip[data-v-1627e5be] {\n  margin-top: 100px;\n  text-align: center;\n}\n.success-tip img[data-v-1627e5be] {\n  width: 40px;\n  vertical-align: middle;\n}\n.success-tip span[data-v-1627e5be] {\n  vertical-align: middle;\n}\n.down-link[data-v-1627e5be] {\n  display: inline-block;\n  margin-top: 100px;\n  width: 100%;\n  text-align: center;\n  font-size: 16px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1627e5be","scoped":true,"hasInlineConfig":false}!./~/vux-loader/src/after-less-loader.js!./~/less-loader/dist/cjs.js?{"sourceMap":false}!./~/vux-loader/src/style-loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/downLoad.vue
// module id = 257
// module chunks = 1